import { AutogenModelEdischedule, AutogenRowEdischedule } from "./autogen/AutogenModelEdischedule";

export class ModelEdischedule extends AutogenModelEdischedule<RowEdischedule> {
	constructor() {
		super(RowEdischedule);
	}
}

export class RowEdischedule extends AutogenRowEdischedule {
}